import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-onboarding-benefit-view',
  templateUrl: './benefit-view.component.html',
  styleUrls: ['./benefit-view.component.scss'],
  standalone: false
})
export class BenefitViewComponent {

  @Input() benefitTitle!: string;
  @Input() messages!: string[];
  @Output() nextClicked: EventEmitter<any> = new EventEmitter<any>();

  submitted: boolean = false;

  constructor() {}

  handleNextClick() {
    this.submitted = true;
    this.nextClicked.emit();
  }
}
